import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// The app, or on production for now a coming-soon page. vite.config.ts picks
// which at build time, so a coming-soon build never contains the app, its
// database client or its keys. Type-checked as the app (tsconfig.json paths).
import Root from "@site-root";
// Brand fonts, bundled and served from this origin rather than Google Fonts, so
// the page depends on one host, not two, on a weak connection. This is not an
// offline start: there is no service worker, and the app needs signal to load.
// Latin only, and only the weights the stylesheet uses.
import "@fontsource/outfit/latin-600.css";
import "@fontsource/plus-jakarta-sans/latin-400.css";
import "@fontsource/plus-jakarta-sans/latin-500.css";
import "@fontsource/plus-jakarta-sans/latin-600.css";
import "@fontsource/plus-jakarta-sans/latin-700.css";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
